<p-toast position="bottom-right"></p-toast>
<p-confirmDialog appendTo="body"></p-confirmDialog>
<app-customer-sidebar>
  <app-crud-table body [crudService]="crudService"
                   [transPartKey]="'owner'" [fieldId]="'id'" [fieldName]="'code'"
                   [tableConfig]="tableConfig" [newRecord]="newRecord"
                   [(formRecord)]="formRecord" [formConfig]="formConfig"
                   (dialogFormVisibleChange)="$event?onFormShow():{}"
                   [formLoading]="formLoading"
                   [writeRoles]="CCRoles.ROLES_CUSTOMER_WRITE" [totalRecords]="totalRecords"
  ></app-crud-table>
</app-customer-sidebar>
